import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick", "experienceId", "followUpIndex", "followUpType", "followUpText"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef, useCallback, useEffect, useRef } from 'react';
import { ChatPill } from '@atlaskit/rovo-agent-components';
import { AI_MATE_ATTRIBUTES, useAnalytics } from '@atlassian/conversation-assistant-instrumentation';
export var FollowUpButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var onButtonClick = _ref.onClick,
    experienceId = _ref.experienceId,
    followUpIndex = _ref.followUpIndex,
    followUpType = _ref.followUpType,
    followUpText = _ref.followUpText,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useAnalytics = useAnalytics(),
    sendAnalyticsEvent = _useAnalytics.sendAnalyticsEvent;
  var analyticsPropertiesRef = useRef();
  analyticsPropertiesRef.current = _objectSpread({
    followUpIndex: followUpIndex,
    followUpType: followUpType,
    followUpLength: followUpText.length
  }, experienceId ? _defineProperty({}, AI_MATE_ATTRIBUTES.experienceId, experienceId) : {});
  useEffect(function () {
    sendAnalyticsEvent({
      eventType: 'screen',
      name: 'followUpQueryButton',
      attributes: analyticsPropertiesRef.current
    });
  }, [sendAnalyticsEvent]);
  var onClick = useCallback(function (_, analyticsEvent) {
    sendAnalyticsEvent(analyticsEvent.update({
      actionSubjectId: 'followUpQueryButton',
      attributes: _objectSpread(_objectSpread({}, analyticsEvent.payload.attributes), analyticsPropertiesRef.current)
    }));
    onButtonClick();
  }, [onButtonClick, sendAnalyticsEvent]);
  return /*#__PURE__*/React.createElement(ChatPill, _extends({
    onClick: onClick
  }, props, {
    ref: ref
  }), followUpText);
});
export { ChatPill };